module.exports = __webpack_public_path__ + "static/img/fontello.f3d5249.svg";


//////////////////
// WEBPACK FOOTER
// ./~/vue-goodshare/src/fonts/fontello.svg?88483298
// module id = 283
// module chunks = 1